/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ComponentGradesFiltersParams,
  ComponentSizesFiltersParams,
  ComponentSubTypesFiltersParams,
  FilterOptionsList,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Components Categories Filters
 */
export const componentCategoriesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/components/categories`, method: 'GET', signal
    },
      );
    }




export const getComponentCategoriesFiltersQueryKey = () => {
    return [
    'filters','components','categories'
    ] as const;
    }


export const getComponentCategoriesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof componentCategoriesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentCategoriesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentCategoriesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof componentCategoriesFilters>>> = ({ signal }) => componentCategoriesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof componentCategoriesFilters>>, TError, TData>
}

export type ComponentCategoriesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof componentCategoriesFilters>>>
export type ComponentCategoriesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Components Categories Filters
 */

export function useComponentCategoriesFilters<TData = Awaited<ReturnType<typeof componentCategoriesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentCategoriesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentCategoriesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Components Grade Filters
 */
export const componentGradesFilters = (
    params?: MaybeRefOrGetter<ComponentGradesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/components/grades`, method: 'GET',
        params, signal
    },
      );
    }




export const getComponentGradesFiltersQueryKey = (params?: MaybeRefOrGetter<ComponentGradesFiltersParams>,) => {
    return [
    'filters','components','grades', ...(params ? [params] : [])
    ] as const;
    }


export const getComponentGradesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof componentGradesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ComponentGradesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentGradesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentGradesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof componentGradesFilters>>> = ({ signal }) => componentGradesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof componentGradesFilters>>, TError, TData>
}

export type ComponentGradesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof componentGradesFilters>>>
export type ComponentGradesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Components Grade Filters
 */

export function useComponentGradesFilters<TData = Awaited<ReturnType<typeof componentGradesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ComponentGradesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentGradesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentGradesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Components Size Filters
 */
export const componentSizesFilters = (
    params?: MaybeRefOrGetter<ComponentSizesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/components/sizes`, method: 'GET',
        params, signal
    },
      );
    }




export const getComponentSizesFiltersQueryKey = (params?: MaybeRefOrGetter<ComponentSizesFiltersParams>,) => {
    return [
    'filters','components','sizes', ...(params ? [params] : [])
    ] as const;
    }


export const getComponentSizesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof componentSizesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ComponentSizesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentSizesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentSizesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof componentSizesFilters>>> = ({ signal }) => componentSizesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof componentSizesFilters>>, TError, TData>
}

export type ComponentSizesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof componentSizesFilters>>>
export type ComponentSizesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Components Size Filters
 */

export function useComponentSizesFilters<TData = Awaited<ReturnType<typeof componentSizesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ComponentSizesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentSizesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentSizesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Components Sub Type Filters
 */
export const componentSubTypesFilters = (
    params?: MaybeRefOrGetter<ComponentSubTypesFiltersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<FilterOptionsList>(
      {url: `/filters/components/sub-types`, method: 'GET',
        params, signal
    },
      );
    }




export const getComponentSubTypesFiltersQueryKey = (params?: MaybeRefOrGetter<ComponentSubTypesFiltersParams>,) => {
    return [
    'filters','components','sub-types', ...(params ? [params] : [])
    ] as const;
    }


export const getComponentSubTypesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof componentSubTypesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ComponentSubTypesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentSubTypesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentSubTypesFiltersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof componentSubTypesFilters>>> = ({ signal }) => componentSubTypesFilters(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof componentSubTypesFilters>>, TError, TData>
}

export type ComponentSubTypesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof componentSubTypesFilters>>>
export type ComponentSubTypesFiltersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Components Sub Type Filters
 */

export function useComponentSubTypesFilters<TData = Awaited<ReturnType<typeof componentSubTypesFilters>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ComponentSubTypesFiltersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentSubTypesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentSubTypesFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






